<template>
    <div id="contenedor">
      <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <v-card class="table" elevation="4">
              <v-toolbar flat elevation="4">
                  <v-card class="icon">
                      <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large="">mdi-check-network-outline</v-icon>
                  </v-card>
                  <div class="usuario">PERMISOS</div>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px" persistent>
                      <template v-slot:activator="{ on }">
                          <v-btn dark class="botonplus" v-on="on"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
                      </template>
                      <v-card style="display: flex; flex-direction: column; max-height: 90vh;">
                          <v-card-title class="nav" style="flex-shrink: 0;">
                              <span class="headline" style="color:whitesmoke"><v-icon color="white">mdi-check-network-outline</v-icon> {{ formTitle }}</span>
                          </v-card-title>
                          <!-- componente del modal para agregar y actualizar -->
                          <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0;">
                              <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs12 sm12 md12>
                                      <v-autocomplete
                                      persistent-hint
                                      v-model="editedItem.idCargo"
                                      label="Cargo"
                                      :items="cargos"
                                      item-value="idCargo"
                                      item-text="opcion"
                                      ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                      <v-autocomplete
                                      persistent-hint
                                      v-model="editedItem.nombreApp"
                                      label="Aplicación"
                                      :items="apps"
                                      item-value="id"
                                      item-text="nombreApp"
                                      ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                      <v-text-field v-model="editedItem.rol" label="Rol"></v-text-field>
                                  </v-flex>
                              </v-layout>
                              </v-container>
                          </v-card-text>
                          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                          <v-card-actions style="flex-shrink: 0;">
                              <v-spacer></v-spacer>
                              <v-btn color="#1D3C7F"  dark @click="close">Cancelar</v-btn>
                              <v-btn
                              color="#1D3C7F"
                              dark
                              @click="save"
                              :disabled="!editedItem.nombreApp || !editedItem.idCargo ||  !editedItem.rol "
                              >Guardar</v-btn>
                          </v-card-actions>
                      <!-- <pre>{{editedItem}}</pre>  -->
                      </v-card>
                  </v-dialog>
              </v-toolbar> 
              <br>
              <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar Permiso"
              class="text-field"
              single-line
              color="#111c3d"
              ></v-text-field>
              <br>
              <v-data-table 
              :headers="headers" 
              :items="usuariosApp" 
              :search="search"
              style=" border: 2px solid #111c3d;"
              class="elevation-3"
              :key="usuariosApp.opcion"
              >
              <!-- tabla donde se pintan los datos obtenidos del arreglo -->
              <!-- <template v-slot:no-data>
                  <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontro su busqueda</v-alert>
              </template> -->
              </v-data-table>
              <!-- alertas de las acciones que se hacen -->
              <v-snackbar
              v-model="snackbar"
              :bottom="y === 'bottom'"
              :left="x === 'left'"
              :multi-line="mode === 'multi-line'"
              :right="x === 'right'"
              :timeout="timeout"
              :top="y === 'top'"
              :vertical="mode === 'vertical'"
              color="#294697"
              style="color:white"
              >
              {{ text }}
              <v-btn color="#294697" depressed  dark @click="snackbar = false">Cerrar</v-btn>
              </v-snackbar>
            </v-card>
          </v-flex>
      </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      apps: [],
      cargos: [],
      usuariosApp:[],
      rules: {
         required: value => !!value || 'Required.',
         counter: value => value.length <= 20 || 'Maximo 20 characteres',
         email: value => {
           const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
           return pattern.test(value) || 'Invalido e-mail.'
         }
       },
      dialog: false,
      headers: [
        {
          text: "Id",
          value: "idUsuariosAplicaciones",
          align: "center",
          class: "column"
        },
        {
          text: "CARGO",
          value: "opcion",
          align: "center",
          class: "column"
        },
        {
          text: "APP",
          align: "center",
          value: "nombreApp",
          class: "column"
        },
        {
          text: "ROL",
          value: "rol",
          align: "center",
          class: "column"
        }
      ],
      defaultItem: {
        id: "",
        idCargo: "",
        rol:"",
        nombreApp:""
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        idCargo: "",
        rol:"",
        nombreApp:""
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Permisos Aplicación" : "Editar Permisos";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.obtenerApps();
    this.obtenerUsuarios();
    this.obtenerCargos();
  },

  methods: {

// Metodo para obtener las aplicaciones
     obtenerApps() {
      axios.get(`${env.endpoint}user/apps`).then(res => (this.apps = res.data));
    }, 
    obtenerUsuarios(){
      axios.get(`${env.endpoint}user/permisos`).then(res =>{
        for (let index = 0; index < res.data.length; index++) {
          res.data[index].opcion= res.data[index].nombreCargo+" ("+res.data[index].areas+")"
          res.data[index].id=index;
        }
        this.usuariosApp=res.data
      });
    },
// Metodo para obtener las aplicaciones
     obtenerCargos() {
      axios.get(`${env.endpoint}user/cargos`).then(res =>{
          for (let index = 0; index < res.data.length; index++) {
              res.data[index].opcion= res.data[index].nombreCargo+" ("+res.data[index].cc_nombre_area+")"
          }
          this.cargos=res.data
      });
    }, 

/**
 * Metodo para agregar fila de la tabla en la modal
 */
    editItem(item) {
      this.editedIndex = this.usuariosApp.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

/**
 * Metodo para cerrar la modal
 */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

/**
 * Metodo para guardar y actualizar
 */
    save() {
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevoPermiso = JSON.stringify({
          idCargo: this.editedItem.idCargo,
          rol:this.editedItem.rol.toLowerCase(),
          nombreApp:this.editedItem.nombreApp
        });        
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_permiso?permiso=${nuevoPermiso}`)
          .then(res => {
            if (res.data.mensaje === "permiso registrado") {
              (this.snackbar = true),
                (this.text = "Permiso registrado satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error permiso existe") {
              (this.snackbar = true),
                (this.text = "El usuario ya tiene el permiso");
            }
            this.obtenerCargos();
            this.obtenerApps();
          });
      this.close();
    }
  }
};
</script>